[
	{
		"groupId": "food",
		"nameKo": "식음료",
		"sortOrder": 1,
		"colorToken": "--color-primary"
	},
	{
		"groupId": "daily",
		"nameKo": "생활·편의",
		"sortOrder": 2,
		"colorToken": "--color-secondary"
	},
	{
		"groupId": "shop",
		"nameKo": "쇼핑",
		"sortOrder": 3,
		"colorToken": "--color-accent"
	},
	{
		"groupId": "beauty",
		"nameKo": "뷰티·미용",
		"sortOrder": 4,
		"colorToken": "--color-primary-strong"
	},
	{
		"groupId": "health",
		"nameKo": "건강·의료",
		"sortOrder": 5,
		"colorToken": "--color-success"
	},
	{
		"groupId": "transport",
		"nameKo": "교통·이동",
		"sortOrder": 6,
		"colorToken": "--color-warning"
	},
	{
		"groupId": "culture",
		"nameKo": "문화·여가",
		"sortOrder": 7,
		"colorToken": "--color-info"
	},
	{
		"groupId": "edu",
		"nameKo": "교육·학습",
		"sortOrder": 8,
		"colorToken": "--color-secondary-strong"
	},
	{
		"groupId": "home",
		"nameKo": "주거·생활서비스",
		"sortOrder": 9,
		"colorToken": "--color-ink-muted"
	},
	{
		"groupId": "pet",
		"nameKo": "반려",
		"sortOrder": 10,
		"colorToken": "--color-primary"
	},
	{
		"groupId": "social",
		"nameKo": "관계·선물",
		"sortOrder": 11,
		"colorToken": "--color-accent-text"
	},
	{
		"groupId": "etc",
		"nameKo": "기타",
		"sortOrder": 12,
		"colorToken": "--color-ink-subtle"
	}
]
